import { buildTestIds, getPaymentOptions } from "application";
import { theme } from "ui";
import * as CardsFlagSub from "./CardsFlags.styles";

export const CardsFlags = () => {
  const payments = getPaymentOptions();

  return (
    <CardsFlagSub.Container {...buildTestIds("cards-flags-container")}>
      <CardsFlagSub.Flags {...buildTestIds("cards-flags")}>
        {payments &&
          payments?.creditCards?.map((payment) => {
            return (
              <CardsFlagSub.Card
                {...buildTestIds(`card-flag-${payment.alt}`)}
                key={payment.alt}
                src={payment.src}
                alt={payment.alt}
                width={theme.space.x9}
                height={theme.space.x7}
              />
            );
          })}
      </CardsFlagSub.Flags>
    </CardsFlagSub.Container>
  );
};
